@if (!collapsed) {
  <div class="flex flex-column h-full w-20rem">
    <div class="flex-grow-1 w-full flex flex-row overflow-hidden">
      <p-menu [model]="items()" class="flex-grow-1 pt-3 pl-1 overflow-x-hidden overflow-y-auto">
        <ng-template pTemplate="item" let-item>
          <a class="navbar-item p-menuitem-link flex text-color no-underline" [style]="{'padding-left' : '27px'}"
             [class.navbar-item-active]="item.active"
             [routerLink]="item.routerLink">
            <div class="flex align-items-center gap-3">
              <span class="navbar-icon flex-shrink-0 text-xl" [class]="item.icon"
                    pTooltip="{{ item.label }}"></span>
              <span>{{ item.label }}</span>
            </div>
          </a>
        </ng-template>
      </p-menu>
    </div>
    <div class="pl-6 pb-4">
      <div class="flex flex-row align-content-end">
        @if (userStore.isCorporateMode()) {
          <img class="flex-1 pb-2" src="/images/DZB%20Logo%20LICo.svg" width="110" alt="LICO Logo">
        } @else {
          <img class="flex-1 pb-2" src="/images/DZB%20Logo%20LiOn.svg" width="110" alt="LiOn Logo">
        }
        <p-button class="flex-none align-self-end p-0 pr-2" icon="pi pi-chevron-left"
                  [rounded]="false" [text]="true" severity="secondary" variant="outlined"
                  (onClick)="toggle()"/>
      </div>
    </div>
  </div>
}
@if (collapsed) {
  <div class="flex flex-column h-full w-5rem">
    <div class="flex-grow-1 w-full flex flex-row overflow-hidden">
      <p-menu [model]="items()" class="pt-0 pl-1 overflow-x-hidden overflow-y-auto">
        <ng-template pTemplate="item" let-item>
          <a class="navbar-item p-menuitem-link flex text-color no-underline"
             [class.navbar-item-active]="item.active"
             [routerLink]="item.routerLink">
            <div class="flex align-items-center gap-3">
              <span class="navbar-icon flex-shrink-0 text-xl"
                    [class]="item.icon"
                    pTooltip="{{ item.label }}"></span>
            </div>
          </a>
        </ng-template>
      </p-menu>
    </div>
    <div class="flex-none flex flex-column h-10rem align-items-center">
      <img class="flex-1 -rotate-90 pb-1 pl-3" src="../../../../../../public/images/DZB%20Logo%20LiOn.svg" width="100"
           alt="LiOn Logo">
      <p-button class="flex-none pb-2" icon="pi pi-chevron-right"
                [rounded]="false" [text]="true" severity="secondary" variant="outlined"
                (onClick)="toggle()"/>
    </div>
  </div>
}
